import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useSmsFormSchema = () => {
  const { t } = useTranslation();

  return z.object({
    isActive: z.literal(true, {
      errorMap: () => ({
        message: t("smsModal.form.fields.isActive.errors.required"),
      }),
    }),
    phoneNumber: z
      .string()
      .min(1, t("smsModal.form.fields.phoneNumber.errors.required")),
  });
};
